import React from "react";
const daysInWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function CalendarGrid({ events, onDateClick }) {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const totalDays = endOfMonth.getDate();

  const grid = [];
  for (let i = 1; i <= totalDays; i++) {
    const date = new Date(today.getFullYear(), today.getMonth(), i);
    grid.push(date);
  }

  return (
    <div>
      <div className="grid grid-cols-7 text-center font-semibold mb-2">
        {daysInWeek.map((d) => (
          <div key={d}>{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-2">
        {grid.map((date, idx) => {
          const formatted = date.toISOString().split("T")[0];
          const dayEvents = events.filter((e) => e.date === formatted);
          return (
            <div
              key={idx}
              className="border rounded p-2 h-24 cursor-pointer hover:bg-gray-100"
              onClick={() => onDateClick(formatted)}
            >
              <div className="text-sm font-bold">{date.getDate()}</div>
              {dayEvents.map((e, i) => (
                <div key={i} className="text-xs truncate">
                  {e.title}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}